<template>
  <div>
    <label>Clients</label>
    <AppSelect
      v-model="selected"
      :options="options"
      :async-delay="5"
      :select2-options="select2Options"
    />
  </div>
</template>

<script>
export default {
  name: 'WorkOrdersClientFilter',
  props: {
    value: {
      type: [Number, String],
      default: () => null,
    },
    options: {
      type: Array,
      required: true,
    },
  },
  emits: ['input'],
  data() {
    return {
      select2Options: Object.freeze({
        width: '100%',
        multiple: false,
        allowClear: true,
        label: 'Clients',
        placeholder: 'All clients',
      }),
    };
  },
  computed: {
    selected: {
      get() {
        return this.value || null;
      },
      set(queryValue) {
        this.$emit('input', queryValue);
      },
    },
  },
};
</script>
